import {LoadSpacingConfiguration, SpacingOrFlowRate} from './types'

export const shouldPreserveSpacingOrFlowRate = (
  configuration: LoadSpacingConfiguration['loadSpacing'],
  originalSpacingType: SpacingOrFlowRate['type'] | undefined
): boolean =>
  configuration.isEnabled &&
  configuration.orderChange !== undefined &&
  originalSpacingType !== undefined &&
  configuration.orderChange.disabledFields.includes(originalSpacingType)
